export const MEDIA_QUERIES = {
  MOBILE: "(max-width: 900px)",
  TABLET: "(min-width: 751px) and (max-width: 1199px)",
  MOBILE_AND_TABLET: "(min-width: 481px) and (max-width: 750px)",
  DESKTOP: "(min-width: 1200px)",
  PIP: "(max-width: 200px)",
};
